import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'expandable-content',
  setup(__props) {

const IconArrow = defineAsyncComponent(() => import("@white-label-icon/icon-arrow"));

const expandableIsActive = ref(false);

const toggleExpandable = () => {
  expandableIsActive.value = !expandableIsActive.value;
};

return { __sfc: true,IconArrow, expandableIsActive, toggleExpandable }
}

})